import { render, staticRenderFns } from "./SynopticTemplatesModal.vue?vue&type=template&id=3beb2f86&scoped=true&"
import script from "./SynopticTemplatesModal.vue?vue&type=script&lang=js&"
export * from "./SynopticTemplatesModal.vue?vue&type=script&lang=js&"
import style0 from "./SynopticTemplatesModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SynopticTemplatesModal.vue?vue&type=style&index=1&id=3beb2f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beb2f86",
  null
  
)

export default component.exports